/**
 * AbstractPopupMediator.js
 * Created on 12-okt-2015
 *
 *
 * @author Reinier Feijen for Ranj
 **/

import AbstractMediator from "./AbstractMediator";
import NavigateEvent from "../navigation/NavigateEvent";
import ClickEaterFactory from "./ClickEaterFactory";
import LayoutManager from "../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";

export default class AbstractPopupMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
    }

    initialize() {
        super.initialize();

        if (this._target.closeButton) {
            this._closeButton = this.createButton(this._target.closeButton, this.handleCloseClick.bind(this));
        }
    }

    handleCloseClick(evt) {
        this.close();
    }

    close() {
        let commandEvent = new NavigateEvent(NavigateEvent.CLOSE_POP_UP_REQUEST, null, this._target);
        this.dispatch(commandEvent.type, { data: commandEvent });

        let onClose = this._target.onClose;
        if (onClose != null) {
            onClose();
        }
    }
}